module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download-manager",
    style: ({
      'padding': _vm.downloading.length > 0 ? '10px' : 0
    })
  }, [_vm._l((_vm.downloading), function(file) {
    return _c('div', [_c('div', {
      staticClass: "file-wrapper"
    }, [_c('div', {
      staticClass: "filename"
    }, [_vm._v("\n                " + _vm._s(file.name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "steps"
    }, [_c('div', {
      staticClass: "step",
      class: {
        'active': file.activeStep === 'downloading'
      }
    }, [_c('div', {
      staticClass: "step-label"
    }, [_vm._v("\n                    Transferring:\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "bar-wrapper"
    }, [_c('span', {
      class: {
        'dark': file.downloadPercentage > 45
      }
    }, [_vm._v(_vm._s(file.downloadPercentage) + "%")]), _vm._v(" "), _c('div', {
      staticClass: "bar",
      style: ({
        'width': file.downloadPercentage + '%'
      })
    })])]), _vm._v(" "), _c('div', {
      staticClass: "step",
      class: {
        'active': file.activeStep === 'processing'
      }
    }, [_c('div', {
      staticClass: "step-label"
    }, [_vm._v("\n                    Processing:\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "bar-wrapper"
    }, [_c('span', {
      class: {
        'dark': file.processedPercentage > 45
      }
    }, [_vm._v(_vm._s(file.processedPercentage) + "%")]), _vm._v(" "), _c('div', {
      staticClass: "bar",
      style: ({
        'width': file.processedPercentage + '%'
      })
    })])]), _vm._v(" "), _c('div', {
      staticClass: "step",
      class: {
        'active': file.activeStep === 'archiving'
      }
    }, [_c('div', {
      staticClass: "step-label"
    }, [_vm._v("\n                    Archiving:\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "bar-wrapper"
    }, [_c('span', {
      class: {
        'dark': file.archivedPercentage > 45
      }
    }, [_vm._v(_vm._s(file.archivedPercentage) + "%")]), _vm._v(" "), _c('div', {
      staticClass: "bar",
      style: ({
        'width': file.archivedPercentage + '%'
      })
    })])]), _vm._v(" "), _c('div', {
      staticClass: "step",
      class: {
        'active': file.activeStep === 'finalizing'
      }
    }, [_c('div', {
      staticClass: "step-label"
    }, [_vm._v("\n                    Finalizing:\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "bar-wrapper"
    }, [_c('span', {
      class: {
        'dark': file.finalizedPercentage > 45
      }
    }, [_vm._v(_vm._s(file.finalizedPercentage) + "%")]), _vm._v(" "), _c('div', {
      staticClass: "bar",
      style: ({
        'width': file.finalizedPercentage + '%'
      })
    })])])])])])
  }), _vm._v(" "), (_vm.downloading.length > 0 && _vm.allFilesDownloaded) ? _c('i', {
    staticClass: "fa fa-close close-download-widget",
    on: {
      "click": function($event) {
        _vm.closeDownloads()
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-612c0170!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/download-manager/DownloadManager.vue
// module id = 2057
// module chunks = 2